document.addEventListener("DOMContentLoaded", function() {
  document.documentElement.style.removeProperty('--nav-family');
});
document.addEventListener("DOMContentLoaded", function() {
  // List of XPath expressions
  const xpaths = [
    "/html/body/div[1]/div/main/div[7]/section/div[2]/div/a",
    "/html/body/div[1]/div/main/div[4]/section/article/div[2]/a",
    "//*[@id='footer-EMAIL']",
    "//*[@id='footer-subscribe']",
    "//*[@id='sort-by--template--27572103413841__main']",
    "//*[@id='Filter-Price-2--1__main--from']",
    "//*[@id='Filter-Price-2--1__main--to']",
    "/html/body/div[1]/div/main/div[2]/div/div[1]/div[2]/div/div[1]/div[2]/div/dl[1]/dd/span",
    "/html/body/div[1]/div/main/div[2]/div/div[1]/div[2]/div/div[5]/form/div/label",
    "/html/body/div[1]/div/main/div[2]/div/div[1]/div[2]/div/div[6]/div/div",
    "/html/body/div[1]/div/main/div[2]/div/div[1]/div[2]/div/div[7]/form/div[1]/input",
    "/html/body/div[1]/div/main/div[2]/div/div[1]/div[2]/div/div[7]/form/div[2]/shopify-accelerated-checkout/shopify-buy-it-now-button/button",
    "/html/body/aside[2]/section/div[3]/form/div[3]/div[2]/a",
    "//*[@id='contact']"


  ];

  // Desired font-family
  const newFont = "'Font-1777361637529', sans-serif";

  // Loop through each XPath
  xpaths.forEach(xpath => {
    const result = document.evaluate(
      xpath,
      document,
      null,
      XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
      null
    );

    // Apply font-family to all matched nodes
    for (let i = 0; i < result.snapshotLength; i++) {
      result.snapshotItem(i).style.fontFamily = newFont;
    }
  });
});
